import type { z } from "zod";

import { UserRoleEntity } from "../../../model";

const zOutSchema = UserRoleEntity.zSchema
  .pick({
    id: true,
  })
  .extend({
    name: UserRoleEntity.zSchema.shape.name.nullable(),
    description: UserRoleEntity.zSchema.shape.description.nullable(),
  });
type OutSchema = z.infer<typeof zOutSchema>;

export { zOutSchema };
export type { OutSchema };
